<template>
  <transition name="el-zoom-in-bottom">
    <div id="testdialog"
         v-show="show2"
         class="proper"
         :style="properStyle"
         v-properDrag>
      <button type="button"
              aria-label="Close"
              @click="show2 = false"
              class="el-dialog__headerbtn">
        <i class="el-dialog__close el-icon el-icon-close"></i>
      </button>
      <div class="proper_header"></div>
      <div class="proper-content">
        <div :is="currentView"></div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'dragModel',
  props: ['currentView', 'show2'],
  data() {
    return {

    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/common/dragModel.vue